import { createApp } from 'vue'
import Kup from './Kup.vue'
import './assets/global.css'

createApp(Kup).mount('#kup')
